import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import '@tinper/next-ui/dist/tinper-next.css';
import App from './App';
import './components/main.scss';
const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element #root was not found.');
}
ReactDOM.createRoot(rootElement).render(_jsx(React.StrictMode, { children: _jsx(HashRouter, { children: _jsx(App, {}) }) }));
